/**
 * Estilos CSS para o módulo Oferta Formulário
 * Estilos isolados via Shadow DOM
 */

export function getOfertaFormularioStyles(config) {
    const { color, fontFamily, colorBackground, colorSpan, colorTitle, cssPrefix } = config;
    // Cor fixa do texto dentro dos campos de formulário (input/select/dropdown).
    // Esses elementos têm fundo claro hardcoded (#f2f2f2), igual em qualquer tema
    // de página — por isso não usam `colorSpan` (que é o texto secundário sobre o
    // fundo da PÁGINA, e pode ser configurado claro em páginas de tema escuro).
    // Mesmo valor que já era o default antigo de colorSpan, pra não mudar a
    // aparência de quem já usava o widget sem customizar cores.
    const colorFieldText = "#5a6372";

    return `
        :host {
            display: block;
            outline: none;
        }

        :host(:focus),
        :host(:focus-visible),
        :host(:focus-within) {
            outline: none !important;
            box-shadow: none !important;
        }

        .${cssPrefix}-wrapper {
            font-family: ${fontFamily};
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: flex-start;
            gap: 2rem;
            padding: 1.5rem;
            max-width: 62.5rem;
            margin: 0 auto;
            box-sizing: border-box;
            width: 100%;
            background-color: ${colorBackground};
        }

        .${cssPrefix}-header {
            width: 100%;
            text-align: center;
            color: #555;
            font-size: 10px;
            font-weight: 500;
            background: transparent;
            box-sizing: border-box;
        }

        .${cssPrefix}-col1,
        .${cssPrefix}-col2 {
            flex: 1 1 300px;
            min-width: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            box-sizing: border-box;
        }

        .${cssPrefix}-col1 {
            align-items: flex-start;
            gap: 1.2rem;
            text-align: left;
        }

        .${cssPrefix}-image {
            width: 100%;
            max-height: 26.3rem;
            margin: 0;
            padding: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0.5rem;
            overflow: hidden;
        }

        .${cssPrefix}-image img {
            width: 100%;
            height: 100%;
            border-radius: 0.5rem;
            object-fit: cover;
            display: block;
            margin: 0 auto;
        }

        .${cssPrefix}-titulos {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            width: 100%;
        }

        .${cssPrefix}-titulos h2 {
            font-size: 2rem;
            font-weight: bold;
            margin: 0;
            color: ${colorTitle};
        }

        .${cssPrefix}-titulos h3 {
            font-size: 1.125rem;
            color: ${color};
            margin: 0;
        }

        .${cssPrefix}-titulos p {
            font-size: 1rem;
            color: ${colorSpan};
            margin: 0;
        }

        .${cssPrefix}-col2 {
            align-items: stretch;
            min-width: 16rem;
            gap: 0;
        }

        .${cssPrefix}-form {
            width: 100%;
            display: flex;
            flex-direction: column;
        }

        .${cssPrefix}-form h4 {
            margin: 0 0 0.75rem 0; /* Reduzido de 1rem para 0.75rem */
            font-size: 1.1rem;
            color: ${colorTitle};
        }

        .${cssPrefix}-form input:not([type="checkbox"]) {
            width: 100%;
            padding: 0 1rem;
            height: 2.1rem;
            margin-bottom: 0;
            border-radius: 1rem;
            background-color: #f2f2f2;
            border: 1px solid #ccc;
            transition: all 0.3s ease;
            color: ${colorFieldText};
            font-size: 1rem;
            box-sizing: border-box;
        }

        .${cssPrefix}-form input:focus {
            border-color: ${color};
            outline: none;
        }

        .${cssPrefix}-form button {
            padding: 0.8rem;
            width: 100%;
            background: ${color};
            color: #fff;
            border: none;
            border-radius: 0.5rem;
            font-weight: bold;
            cursor: pointer;
            font-size: 1rem;
            transition: all 0.3s ease;
        }

        .${cssPrefix}-form button:hover {
            opacity: 0.8;
        }

        .${cssPrefix}-form button:focus,
        .${cssPrefix}-form button:focus-visible {
            outline: none;
            box-shadow: 0 0 0 3px rgba(0, 169, 157, 0.2);
        }

        .${cssPrefix}-form button:disabled {
            opacity: 0.5;
            cursor: not-allowed;
            background-color: #ccc;
        }

        .${cssPrefix}-checkbox-group {
            text-align: left;
            margin-top: 0.375rem; /* Reduzido de 0.5rem para 0.375rem */
            margin-bottom: 1.125rem; /* Reduzido de 1.5rem para 1.125rem */
            display: flex;
            flex-direction: column;
            gap: 0.5rem; /* Reduzido de 0.75rem para 0.5rem */
        }

        .${cssPrefix}-checkbox-group label {
            display: flex;
            align-items: center;
            font-size: 0.95rem;
            gap: 0.5rem;
        }

        .${cssPrefix}-checkbox-group input[type="checkbox"] {
            margin-top: 0.2rem;
            accent-color: ${color};
        }

        .${cssPrefix}-checkbox-group span {
            color: ${colorSpan};
            line-height: 1.4;
            font-size: 0.75rem;
        }

        .${cssPrefix}-checkbox-group span a,
        .${cssPrefix}-checkbox-group span b,
        .${cssPrefix}-checkbox-group span strong {
            color: ${color};
            transition: color 0.3s ease;
        }

        .${cssPrefix}-checkbox-group span a:hover {
            color: ${colorSpan};
        }

        .${cssPrefix}-checkbox-group span a {
            cursor: pointer;
        }

        .${cssPrefix}-message {
            padding: 0.6rem 1rem;
            border-radius: 0.25rem;
            margin-bottom: 0.75rem; /* Reduzido de 1rem para 0.75rem */
            margin-top: 0.75rem; /* Reduzido de 1rem para 0.75rem */
            display: none;
            font-size: 1rem;
        }

        .${cssPrefix}-message.success {
            background: #00a99d;
            color: #fff;
        }

        .${cssPrefix}-message.error {
            background: #fb2c36;
            color: #fff;
        }

        .${cssPrefix}-birthdate-wrapper {
            position: relative;
            width: 100%;
            margin-bottom: 1rem;
        }

        .${cssPrefix}-birthdate-wrapper input[type="date"] {
            width: 100%;
            padding: 0 1rem;
            height: 2.5rem;
            border-radius: 1rem;
            background-color: #f2f2f2;
            border: 1px solid #ccc;
            transition: all 0.3s ease;
            color: ${colorFieldText};
            font-size: 1rem;
            box-sizing: border-box;
        }

        .${cssPrefix}-birthdate-wrapper input[type="date"]::placeholder {
            color: ${colorFieldText};
        }

        .${cssPrefix}-birthdate-wrapper input[type="date"]::-webkit-calendar-picker-indicator {
            position: absolute;
            right: 1rem;
            cursor: pointer;
            color: #5a6372;
            filter: invert(1) brightness(0.8);
        }

        .${cssPrefix}-birthdate-wrapper input[type="date"]::-webkit-outer-spin-button,
        .${cssPrefix}-birthdate-wrapper input[type="date"]::-webkit-inner-spin-button {
            display: none;
            -webkit-appearance: none;
            margin: 0;
        }

        .${cssPrefix}-birthdate-wrapper input[type="date"]:focus {
            border-color: ${color};
            outline: none;
        }

        .${cssPrefix}-birthdate-placeholder {
            position: absolute;
            left: 1rem;
            top: 35%;
            transform: translateY(-50%);
            color: ${colorFieldText};
            font-size: 1rem;
            pointer-events: none;
            z-index: 10;
            display: block;
            background-color: #f2f2f2;
            padding-right: 0.5rem;
            white-space: nowrap;
            text-shadow: 0 0 0.5px rgba(0, 0, 0, 0.2);
        }

        .${cssPrefix}-error {
            padding: 0.4rem 0;
            margin-top: 0;
            margin-bottom: 0;
            font-size: 0.875rem;
            color: #fb2c36;
            display: block;
            min-height: 1.25rem;
            line-height: 1.4;
        }

        .${cssPrefix}-error:empty {
            margin-bottom: 0.4rem;
            min-height: 0;
        }

        @media (max-width: 425px) {
            .${cssPrefix}-image.hide-mobile {
                display: none !important;
            }
        }

        @media (max-width: 900px) {
            .${cssPrefix}-wrapper {
                flex-direction: column;
                padding: 1rem;
                gap: 2rem;
            }

            .${cssPrefix}-col1,
            .${cssPrefix}-col2 {
                min-width: 0;
                max-width: 100%;
                flex: 1;
                width: 100%;
            }

            .${cssPrefix}-image {
                max-width: 100%;
                height: auto;
            }
        }

        @media (max-width: 600px) {
            .${cssPrefix}-wrapper {
                padding: 0.5rem;
                gap: 2rem;
            }

            .${cssPrefix}-form input {
                font-size: 0.95rem;
                height: 2.1rem;
                padding: 0 0.7rem;
            }

            .${cssPrefix}-form button {
                font-size: 0.95rem;
                padding: 0.6rem;
            }

            .${cssPrefix}-titulos h2 {
                font-size: 1.2rem;
            }

            .${cssPrefix}-titulos h3 {
                font-size: 1rem;
            }

            .${cssPrefix}-titulos p {
                font-size: 0.95rem;
            }
        }

        .fade-in {
            animation: fadeIn 0.5s ease-in;
        }

        @keyframes fadeIn {
            from {
                opacity: 0;
                transform: translateY(10px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }

        /* ====== MULTI-STEP STYLES ====== */
        
        /* Indicador de Progresso */
        .${cssPrefix}-progress-indicator {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            margin: 0.5rem 0 1rem 0;
            padding: 0.5rem;
            box-sizing: border-box;
            opacity: 0.75;
        }

        .${cssPrefix}-progress-step {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 0.25rem;
            flex: 0 0 auto;
        }

        .${cssPrefix}-progress-circle {
            width: 26px;
            height: 26px;
            border-radius: 50%;
            background-color: #f5f5f5;
            color: #bbb;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
            font-size: 0.8rem;
            transition: background-color 0.25s ease, color 0.25s ease, border-color 0.25s ease;
            border: 2px solid #e8e8e8;
        }

        .${cssPrefix}-progress-step-active .${cssPrefix}-progress-circle {
            background-color: ${color};
            color: white;
            border-color: ${color};
        }

        .${cssPrefix}-progress-step span {
            font-size: 0.65rem;
            color: #bbb;
            font-weight: 500;
            text-align: center;
            transition: color 0.25s ease, opacity 0.25s ease;
            opacity: 0.75;
        }

        .${cssPrefix}-progress-step-active span {
            color: ${color};
            font-weight: 600;
            opacity: 1;
        }

        .${cssPrefix}-progress-line {
            height: 2px;
            flex: 1;
            background-color: #e8e8e8;
            margin: 0 0.4rem;
            border-radius: 2px;
            transition: background-color 0.25s ease;
            max-width: 60px;
        }

        .${cssPrefix}-progress-line-active {
            background-color: ${color};
        }

        /* Transições entre Steps */
        .${cssPrefix}-wrapper {
            position: relative;
        }

        .${cssPrefix}-form-step-enter {
            animation: slideInRight 0.4s ease-out;
        }

        .${cssPrefix}-form-step-back {
            animation: slideInLeft 0.4s ease-out;
        }

        @keyframes slideInRight {
            from {
                opacity: 0;
                transform: translateX(30px);
            }
            to {
                opacity: 1;
                transform: translateX(0);
            }
        }

        @keyframes slideInLeft {
            from {
                opacity: 0;
                transform: translateX(-30px);
            }
            to {
                opacity: 1;
                transform: translateX(0);
            }
        }

        .${cssPrefix}-step-buttons {
            display: flex;
            gap: 1rem;
            margin-top: 1rem;
        }

        .${cssPrefix}-btn-back,
        .${cssPrefix}-btn-submit {
            flex: 1;
            padding: 0.8rem;
            border: none;
            border-radius: 0.5rem;
            font-size: 1rem;
            font-weight: bold;
            cursor: pointer;
            transition: all 0.3s ease;
        }

        .${cssPrefix}-btn-back {
            background-color: #6c757d;
            color: white;
        }

        .${cssPrefix}-btn-back:hover {
            background-color: #5a6268;
        }

        .${cssPrefix}-btn-back:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }

        .${cssPrefix}-btn-submit {
            background-color: ${color};
            color: white;
        }

        .${cssPrefix}-btn-submit:hover {
            opacity: 0.8;
        }

        .${cssPrefix}-btn-submit:focus,
        .${cssPrefix}-btn-submit:focus-visible {
            outline: none;
            box-shadow: 0 0 0 3px rgba(0, 169, 157, 0.2);
        }

        .${cssPrefix}-btn-submit:disabled {
            opacity: 0.5;
            cursor: not-allowed;
            background-color: #ccc;
        }

        /* ====== PERGUNTAS LP INTERESSE ====== */
        .${cssPrefix}-question {
            margin-bottom: 0; /* Reduzido de 1rem para 0 */
        }

        .${cssPrefix}-question-label {
            display: block;
            font-size: 0.875rem;
            font-weight: 500;
            color: ${colorTitle};
            margin-bottom: 0.375rem; /* Reduzido de 0.5rem para 0.375rem */
            line-height: 1.4;
        }

        .${cssPrefix}-required-note {
            font-size: 0.75rem;
            color: ${colorSpan};
            margin: 0;
            line-height: 1.4;
        }

        /* ====== MODELOS DE INTERESSE (MULTISELECT) ====== */
        .${cssPrefix}-multiselect {
            position: relative;
            width: 100%;
            margin-bottom: 0.375rem;
        }

        /* Especificidade maior que .form button para nao herdar cor teal do CTA.
           Mesma cor/fonte do .select (colorFieldText) — sem cinza #999 mais apagado. */
        .${cssPrefix}-form button.${cssPrefix}-multiselect-trigger,
        .${cssPrefix}-form button.${cssPrefix}-multiselect-trigger.is-placeholder,
        .${cssPrefix}-form button.${cssPrefix}-multiselect-trigger:hover,
        .${cssPrefix}-form button.${cssPrefix}-multiselect-trigger[aria-expanded="true"],
        .${cssPrefix}-form button.${cssPrefix}-multiselect-trigger:focus,
        .${cssPrefix}-form button.${cssPrefix}-multiselect-trigger:focus-visible {
            width: 100%;
            height: 2.1rem;
            padding: 0 3rem 0 1rem;
            margin: 0;
            border-radius: 1rem;
            background-color: #f2f2f2;
            border: 1px solid #cfd7e3;
            color: ${colorFieldText};
            font-size: 1rem;
            font-family: inherit;
            font-weight: 400;
            font-style: normal;
            letter-spacing: normal;
            line-height: normal;
            text-align: left;
            cursor: pointer;
            box-sizing: border-box;
            opacity: 1;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
            background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
            background-repeat: no-repeat;
            background-position: right 1rem center;
            background-size: 1rem;
            transition: border-color 0.3s ease, box-shadow 0.3s ease;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }

        .${cssPrefix}-form button.${cssPrefix}-multiselect-trigger:hover,
        .${cssPrefix}-form button.${cssPrefix}-multiselect-trigger[aria-expanded="true"] {
            border-color: ${color};
        }

        .${cssPrefix}-form button.${cssPrefix}-multiselect-trigger:focus,
        .${cssPrefix}-form button.${cssPrefix}-multiselect-trigger:focus-visible {
            outline: none;
            border-color: ${color};
            box-shadow: 0 0 0 3px rgba(0, 169, 157, 0.16);
        }

        .${cssPrefix}-multiselect-trigger-text {
            display: block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font: inherit;
            color: inherit;
        }

        .${cssPrefix}-multiselect-dropdown {
            position: absolute;
            top: calc(100% + 0.25rem);
            left: 0;
            right: 0;
            z-index: 20;
            max-height: 12rem;
            overflow-y: auto;
            background: #fff;
            border: 1px solid #cfd7e3;
            border-radius: 0.75rem;
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
            padding: 0.5rem;
            box-sizing: border-box;
        }

        .${cssPrefix}-multiselect-dropdown[hidden] {
            display: none;
        }

        .${cssPrefix}-models-group {
            display: flex;
            flex-direction: column;
            gap: 0.25rem;
            margin-bottom: 0;
        }

        .${cssPrefix}-brand-group {
            display: flex;
            flex-direction: column;
            gap: 0.125rem;
        }

        .${cssPrefix}-checkbox-label {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            cursor: pointer;
            padding: 0.375rem 0.5rem;
            border-radius: 0.5rem;
            transition: background-color 0.2s ease;
        }

        .${cssPrefix}-checkbox-label:hover {
            background-color: rgba(0, 0, 0, 0.05);
        }

        .${cssPrefix}-checkbox-label input[type="checkbox"] {
            width: 1rem;
            height: 1rem;
            accent-color: ${color};
            cursor: pointer;
            flex-shrink: 0;
        }

        .${cssPrefix}-checkbox-text {
            font-size: 0.875rem;
            color: ${colorFieldText};
            line-height: 1.4;
            flex: 1;
        }

        .${cssPrefix}-select {
            width: 100%;
            padding: 0 1rem;
            height: 2.1rem;
            border-radius: 1rem;
            background-color: #f2f2f2;
            border: 1px solid #cfd7e3;
            color: ${colorFieldText};
            font-size: 1rem;
            transition: all 0.3s ease;
            box-sizing: border-box;
            margin-bottom: 0;
            appearance: none;
            cursor: pointer;
            background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
            background-repeat: no-repeat;
            background-position: right 1rem center;
            background-size: 1rem;
            padding-right: 3rem;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
        }

        .${cssPrefix}-select:focus {
            border-color: ${color};
            outline: none;
            box-shadow: 0 0 0 3px rgba(0, 169, 157, 0.16);
        }

        .${cssPrefix}-select:hover:not(:disabled) {
            border-color: ${color};
        }

        .${cssPrefix}-select:disabled {
            cursor: not-allowed;
            background-color: #f4f6f9;
            color: #97a1b2;
        }

        .${cssPrefix}-select:invalid {
            color: #999;
        }

        .${cssPrefix}-select option {
            color: ${colorFieldText};
        }

        .${cssPrefix}-select::placeholder {
            color: ${colorFieldText};
        }

        .${cssPrefix}-state-city-row {
            display: flex;
            gap: 0.5rem;
            width: 100%;
            margin-bottom: 10px;
        }

        .${cssPrefix}-state-city-errors {
            display: flex;
            gap: 0.5rem;
            width: 100%;
        }

        .${cssPrefix}-location-error {
            flex: 1;
            margin-top: 0.25rem;
            margin-bottom: 0.5rem;
            min-height: 0;
            padding: 0;
        }

        .${cssPrefix}-location-error:empty {
            display: none;
            margin: 0;
        }

        .${cssPrefix}-state-city-row .${cssPrefix}-select-half {
            width: 50%;
        }

        .${cssPrefix}-state-city-row input {
            width: 100%;
        }

        .${cssPrefix}-birthdate-wrapper input[type="date"]::selection {
            background-color: ${colorSpan};
        }

        @media (max-width: 600px) {
            .${cssPrefix}-question-label {
                font-size: 0.8rem;
            }

            .${cssPrefix}-state-city-row {
                flex-direction: column;
                gap: 0.5rem;
            }

            .${cssPrefix}-state-city-errors {
                flex-direction: column;
                gap: 0.25rem;
            }

            .${cssPrefix}-state-city-row .${cssPrefix}-select-half {
                width: 100%;
            }

            .${cssPrefix}-select {
                font-size: 0.95rem;
                height: 2.2rem;
                padding-right: 2.5rem;
                background-size: 0.875rem;
            }
        }

        .${cssPrefix}-error {
            color: #dc3545;
            font-size: 0.875rem;
            margin-top: 0;
            margin-bottom: 0;
            display: block;
            line-height: 1.4;
            min-height: 1.25rem;
        }

        .${cssPrefix}-error:empty {
            min-height: 0;
        }

        /* Mensagem de erro por checkbox de opt-in (AC-9): o grupo é um flex
           column com gap, então a div vazia precisa sair do fluxo para não
           criar um espaçamento extra entre os consentimentos. */
        .${cssPrefix}-checkbox-group .${cssPrefix}-error:empty {
            display: none;
            min-height: 0;
            margin: 0;
            padding: 0;
        }

        .${cssPrefix}-checkbox-group .${cssPrefix}-error {
            padding: 0;
            min-height: 0;
        }

        .${cssPrefix}-birthdate-wrapper {
            position: relative;
            margin-bottom: 0;
        }

        .${cssPrefix}-birthdate-wrapper input[type="date"] {
            width: 100%;
            margin-bottom: 0;
        }

        .${cssPrefix}-birthdate-wrapper input[type="text"] {
            color: transparent;
        }

        .${cssPrefix}-birthdate-placeholder {
            position: absolute;
            left: 0.75rem;
            top: 50%;
            transform: translateY(-50%);
            pointer-events: none;
            color: #6c757d;
            font-size: 1rem;
        }

        .${cssPrefix}-birthdate-wrapper input:focus + .${cssPrefix}-birthdate-placeholder,
        .${cssPrefix}-birthdate-wrapper input:not([value=""]) + .${cssPrefix}-birthdate-placeholder {
            display: none;
        }

        @media (max-width: 600px) {
            .${cssPrefix}-step-buttons {
                flex-direction: column;
                gap: 0.5rem;
            }

            .${cssPrefix}-btn-back,
            .${cssPrefix}-btn-submit {
                padding: 0.6rem 1rem;
                font-size: 0.95rem;
            }

            .${cssPrefix}-progress-indicator {
                margin: 0.4rem 0 0.8rem 0;
                padding: 0.4rem;
                opacity: 0.8;
            }

            .${cssPrefix}-progress-circle {
                width: 24px;
                height: 24px;
                font-size: 0.75rem;
            }

            .${cssPrefix}-progress-step span {
                font-size: 0.6rem;
                max-width: 55px;
            }

            .${cssPrefix}-progress-line {
                max-width: 35px;
                margin: 0 0.3rem;
            }
        }
    `;
}
